import { RolexContainer } from '../Container'
import { RolexPushBanner } from './PushBanner'
import { Heading } from '@components/rolex-ui/Heading'
import { cn } from '@lib/cn'
import { RolexPushBanner as RolexPushBannerModel } from '@lib/kontent/models/RolexPushBanner'
import { RolexPushBannerGrid as RolexPushBannerGridModel } from '@lib/kontent/models/RolexPushBannerGrid'
import { FC } from 'react'

type RolexPushBannerGridProps = RolexPushBannerGridModel & {
  banners: RolexPushBannerModel[]
  className?: string
}

export const RolexPushBannerGrid: FC<RolexPushBannerGridProps> = ({
  title,
  banners,
  grid_layout,
  className,
}) => {
  let gridLayout: 'n1_column' | 'n2_columns' | 'n3_columns' = 'n1_column'

  if (grid_layout.value[0].codename === 'n2_columns') {
    gridLayout = 'n2_columns'
  }
  if (grid_layout.value[0].codename === 'n3_columns') {
    gridLayout = 'n3_columns'
  }

  return (
    <section className={cn('py-[30px] md:py-[45px] lg:py-[60px]', className)}>
      <RolexContainer as="div">
        <Heading variant="headline36" as="h2" className="mb-5 text-rolexBrown">
          {title.value}
        </Heading>
        <div
          className={cn(
            'grid grid-cols-1 gap-x-2 gap-y-12',
            gridLayout === 'n2_columns' && 'md:grid-cols-2',
            gridLayout === 'n3_columns' && 'md:grid-cols-3',
          )}
        >
          {banners.map((banner) => (
            <RolexPushBanner
              key={banner.title.value}
              pretitle={banner.pretitle.value}
              title={banner.title.value}
              buttonLink={banner.button_link.value}
              buttonText={banner.button_text.value}
              mobileImage={banner.mobile_image}
              desktopImage={banner.desktop_image}
              gridLayout={gridLayout}
            />
          ))}
        </div>
      </RolexContainer>
    </section>
  )
}
